import TourGamesUserTicketView from './TourGamesUserTicketView';
export default TourGamesUserTicketView;
